export default __webpack_public_path__ + "static/media/heroLadyM.8f026a7a.jpg";